import React, { useState, useContext } from "react";
import "./index.scss";
import { Row, Col, Select } from "antd";
import { DashboardEndpoints } from "@DASHBOARD";
import { AuthContext } from "@CONTEXTS";
import { useGET } from "@API2";
import MainSlider from "./main-slider";
import B2BDashboard from "./b2b";

const StandardDashboard = ({ info }) => {
  const [selectedMerchant] = useState(
    sessionStorage.getItem("merchantId") === "null" ||
      sessionStorage.getItem("merchantId") === null
      ? null
      : Number(sessionStorage.getItem("merchantId"))
  );
  const [channel, setChannel] = useState(
    info?.onlyJetpartnerDeliveries
      ? "JETPARTNER"
      : sessionStorage.getItem("channel") === null
      ? "JETPARTNER"
      : sessionStorage.getItem("channel") === "null"
      ? null
      : sessionStorage.getItem("channel") === "INTEGRATION"
      ? "INTEGRATION"
      : sessionStorage.getItem("channel")
  );
  const [channelList] = useState(
    info?.onlyJetpartnerDeliveries
      ? [{ value: "JETPARTNER", label: "JETPARTNER" }]
      : [
          { value: null, label: "Tüm Kanallar" },
          { value: "JETPARTNER", label: "JETPARTNER" },
          {
            value: "INTEGRATION",
            label: "DİĞER KANALLAR",
          },
        ]
  );

  const { data, loading } = useGET(
    DashboardEndpoints.getDashboard,
    `?merchantId=${selectedMerchant ? selectedMerchant : ""}&channel=${
      channel ? channel : ""
    }`
  );

  const deliveryData = data;

  if (loading) {
    return <Select disabled loading placeholder="Yükleniyor..." />;
  }

  return (
    <div className="app-dashboard">
      <Row gutter={16}>
        <Col span={24}>
          <div className="main-slider">
            <MainSlider
              data={deliveryData}
              selectedMerchant={selectedMerchant}
              info={info}
              setChannel={setChannel}
              channel={channel}
              channelList={channelList}
            />
            <Row gutter={16} className="dashboard-deliveryBox-row">
              <Col span={24}>
                <p className="dashboard-red-text">
                  15 günlük gönderiler baz alınmıştır.
                </p>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const Dashboard = () => {
  const { info } = useContext(AuthContext);

  if (info?.specialTags?.includes("B2BPRO")) {
    return <B2BDashboard />;
  }

  return <StandardDashboard info={info} />;
};

export default React.memo(Dashboard);
